import * as React from 'react';

import { useApiCallable } from '../../../api';
import { getApiErrorMessage } from '../../../api/hub-api-request';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Text,
} from '../../../components';

type Props = {
  ideaId: string;
  invalidate: () => unknown;
  onClose: () => void;
};

export default function CancelIdeaModal({
  ideaId,
  invalidate,
  onClose,
}: Props) {
  const callApi = useApiCallable();
  const [cancelling, setCancelling] = React.useState(false);

  const cancel = async () => {
    if (cancelling) return;
    setCancelling(true);
    try {
      await callApi(`/wishlist-ideas/${ideaId}/cancel`, { method: 'POST' });
      onClose();
      invalidate();
    } catch (err) {
      alert(getApiErrorMessage(err));
      setCancelling(false);
    }
  };

  return (
    <Modal size="confirm" onClose={onClose}>
      <ModalBody size="confirm">
        <Text typeface="headline" color="neutral100" as="h2">
          Cancel idea
        </Text>
        <Text typeface="body.small.regular" color="neutral60">
          Are you sure you want to cancel this idea? It will move to the
          Cancelled column.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Button
          label="Keep idea"
          variant="text"
          colorScheme="black"
          onClick={onClose}
        />
        <Button label="Cancel idea" disabled={cancelling} onClick={cancel} />
      </ModalFooter>
    </Modal>
  );
}
